export const iconFontAwesomeGendersMercury = (
	<i className="fa-solid fa-mercury"></i>
);
